import { useMutation } from '@tanstack/react-query';
import { container } from '@src/container';
import { AuthService } from '@src/application/users/usecases';

/**
 * Hook: useVerifyOtp
 * Verifies OTP and authenticates user
 * 
 * @example
 * const { mutate: verifyOtp, isPending } = useVerifyOtp();
 * verifyOtp({ email: 'user@example.com', code: '123456' });
 */
export function useVerifyOtp() {
    const authService = container.resolve<AuthService>('authService');

    return useMutation({
        mutationFn: async ({ email, code }: { email: string; code: string }) => {
            return await authService.verifyOtp(email, code);
        },
        // Disable retries for OTP verification
        retry: false,
    });
}
